import { actionAddException } from 'react-redux-app/lib/modules/exception/actions';

import {
  ACTION_LOAD_PAYOUT_REQUEST_AVAILABILITY__REQUEST,
  ACTION_LOAD_PAYOUT_REQUEST_AVAILABILITY__SUCCESS,
  ACTION_LOAD_PAYOUT_REQUEST_AVAILABILITY__FAIL,
} from '../actionTypes';


export const actionLoadPayoutRequestAvailabilitySuccess = availability => ({
  type: ACTION_LOAD_PAYOUT_REQUEST_AVAILABILITY__SUCCESS,
  payload: { availability },
});

const actionLoadPayoutRequestAvailabilityFail = error => ({
  type: ACTION_LOAD_PAYOUT_REQUEST_AVAILABILITY__FAIL,
  payload: { error },
});

export const actionLoadPayoutRequestAvailability = () => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_LOAD_PAYOUT_REQUEST_AVAILABILITY__REQUEST,
    });

    return apiClientHelper.get(
      '/rest/webmaster/payout_request/availability'
    ).then(
      availability => {
        dispatch(actionLoadPayoutRequestAvailabilitySuccess(availability));
      },
      error => {
        dispatch(actionLoadPayoutRequestAvailabilityFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);
